import { openIxdForwardModal } from "@/components/modals/ixd-forward";
import { openUploadDsdModal } from "@/components/modals/upload-dsd";
import { PageHeader } from "@/components/team-workspace/page-header";
import { RecentReportsContainer } from "@/components/recent-reports";
import { ReportListContainer } from "@/components/team-workspace/report-list/report-list-container";
import { LeftSidebar } from "@/components/app-shell";

const MainContent = () => (
  <div className="relative flex-1 h-full self-stretch overflow-y-auto bg-white">
    {/* 콘텐츠 폭 1200 고정 — 창이 더 좁으면 행·카드를 짜부러뜨리는 대신 가로 스크롤로 넘기고,
        1920 처럼 넓으면 늘리지 않고 가운데에 둔다(남는 폭은 좌우 여백).
        상한 1328 = 콘텐츠 1200 + px-16 좌우 64. border-box 라 패딩이 폭에 포함되므로,
        `/`·`/ixd-editor` 처럼 패딩을 바깥에 둔 화면과 콘텐츠 폭을 맞추려면 더해줘야 한다.
        min-w 는 종전 그대로 박스 1200 — 좁은 창의 가로 스크롤 동작을 바꾸지 않는다.
        (바깥 div 는 overflow-y-auto 라 가로축도 auto 로 계산돼 스크롤 컨테이너가 된다.) */}
    <div className="mx-auto flex min-w-[1200px] max-w-[1328px] flex-col gap-10 px-16 py-16">
      <PageHeader
        onUpload={openUploadDsdModal}
        onIxdForward={openIxdForwardModal}
      />
      <RecentReportsContainer />
      <ReportListContainer />
    </div>
  </div>
);

const DSDListWorkspace = () => (
  <div className="inline-flex w-full h-full items-center relative">
    <LeftSidebar activeMenu="workbooks" />
    <MainContent />
  </div>
);

export default DSDListWorkspace;
